// extracted by mini-css-extract-plugin
module.exports = {"commercial-invoice":"CommercialInvoice_commercial-invoice__vDa7p","container":"CommercialInvoice_container__FV_L3"};